module.exports = __webpack_public_path__ + "img/pp_27.3764ff62.png";